import React from 'react';
import styles from './Hero.module.css';

const Hero = ({ image }) => {
  return (
    <div className={styles.container}>
      <img src={image} alt="" className={styles.image} />
    </div>
  );
};

export default Hero;
